import css from "./LoginButtonList.module.scss";

import React from "react";

const LoginButtonList: React.FC<React.PropsWithChildren> = ({ children }) => (
    <div className={css.LoginButtonList}>{children}</div>
);

export default LoginButtonList;
